import { Loader } from '../utils/loader.js';
import { sleep, animateCSS, vis } from '../utils/helpers';
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';

export class BusinessTypesShortcode {
	constructor() {
		this.init = () => {
			let swiperOptions = {
				// Install modules
				direction: 'horizontal',
				modules: [Navigation, Pagination, Scrollbar],
				speed: 500,
				slidesPerView: 2,
				watchOverflow: false,
				loop: false,
				centeredSlides: false,
				scrollbar: {
					el: '.swiper-scrollbar-drag',
					draggable: true,
					enabled: true,
					dragClass:'swiper-scrollbar-drag',
					dragSize: '48',
				},
				multipleActiveThumbs: true,
				slideNextClass: 'swiper-slide-active',
				spaceBetween: 40,
				slidesOffsetBefore: 150,
				slidesOffsetAfter: 150,
				breakpoints: {
					1024: {
						slidesPerView: 5,
					},

				}
			};

			const swiperContainer = document.querySelector('.business_types-wrapper.swiper');
			if(swiperContainer && swiperContainer.classList.contains('business_types--square-layout')) {
				swiperOptions = {};
				swiperOptions.slidesPerView = 'auto';
				swiperOptions.modules = [Navigation, Pagination, Scrollbar];
				// swiperOptions.scrollbar = {};
				swiperOptions.navigation = {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				};
				swiperOptions.freeMode = true;
				swiperOptions.slidesOffsetBefore = 10;
				swiperOptions.slidesOffsetAfter = 10;
				swiperOptions.breakpoints = {
					1024: {
						slidesOffsetBefore: 50,
						slidesOffsetAfter: 50
					},

				};
				swiperOptions.on = {
					init: function () {
						setTimeout(() => {
							var totalWidth = 0;
							this.slides.forEach(function (slide) {
								totalWidth += slide.offsetWidth;
							});
							this.wrapperEl.style.width = totalWidth + 'px';
						}, 1000);

					},
				};
			}
			const swiper = new Swiper('.business_types-wrapper.swiper', swiperOptions);
			swiper.scrollbar.updateSize();
		};
		this.loader = new Loader();


		this.initSelectors();
		this.initState();
		this.addEventListeners();
	}

	initSelectors() {
		this.selectors = {
			desktop: {
				wrapper: jQuery('.nx_business_types_widget-desktop .swiper'),
				filterForm: {
					wrapper: jQuery('.nx_business_types_widget-desktop form'),
					select: jQuery(
						'.nx_business_types_widget-desktop form select'
					),
					option: jQuery('.nx_business_types_widget-desktop form li'),
					selectUnattended: jQuery(
						'.nx_business_types_widget-desktop select[name=business_type_unattended]'
					),
					selectRetail: jQuery(
						'.nx_business_types_widget-desktop select[name=business_type_ecommerce]'
					),
					selectEcommerce: jQuery(
						'.nx_business_types_widget-desktop select[name=business_type_transit]'
					),
				},

				slider: jQuery(
					'.nx_business_types_widget-desktop .navigation-slider input'
				),
			},
			mobile: {
				wrapper: jQuery('.nx_business_types_widget-mobile'),
				button: jQuery('.nx_business_types_widget-mobile .item button'),
				panel: jQuery('.nx_business_types_widget-mobile .item .panel'),
			},
			nonce: jQuery('#nx_business_types_widget_nonce'),
		};
	}

	initState() {
		this.state = {
			desktop: {
				cache: new Map(),
				key: '',
				startPos: 0,
				screensAmount: 0,
			},
			nonce:
				this.selectors.nonce.length > 0
					? this.selectors.nonce.val()
					: '',
		};

		if (typeof BUSINESS_TYPE_SHORTCODE_CONFIG === 'undefined') {
			return;
		}

		Object.keys(BUSINESS_TYPE_SHORTCODE_CONFIG).forEach((key) => {
			this.state.desktop[key] =
				BUSINESS_TYPE_SHORTCODE_CONFIG[key].post_ids;
		});
	}

	addEventListeners() {
		const selectors = this.selectors;
		selectors.desktop.filterForm.wrapper.on('submit', (event) =>
			this.filterFormSubmitHandler(event)
		);
		selectors.desktop.filterForm.select.on('change', (event) =>
			this.filterFormSelectChangeHandler(event)
		);
		selectors.mobile.button.on('click', (e) =>
			this.accordionMobileClickHandler(e)
		);
		jQuery(document).on(
			'mouseenter touchstart',
			'.nx_business_types_widget-desktop .business_type',
			this.businessTypeItemEnterHandler
		);
		jQuery(document).on(
			'mouseleave touchend',
			'.nx_business_types_widget-desktop .business_type',
			this.businessTypeItemLeaveHandler
		);
		selectors.mobile.button.on('click', (e) =>
			this.accordionMobileClickHandler(e)
		);
	}
	businessTypeItemEnterHandler() {
		const $target = jQuery(this);
		$target.addClass('hovered');
		const $owlItem = $target.closest('.owl-item');
		if ($owlItem.length > 0) {
			$owlItem.addClass('hovered');
		}
	}

	businessTypeItemLeaveHandler() {
		const $target = jQuery(this);
		$target.removeClass('hovered');
		const $owlItem = $target.closest('.owl-item');
		if ($owlItem.length > 0) {
			$owlItem.removeClass('hovered');
		}
	}
	setCacheKey() {
		const state = this.state.desktop;
		const emptyKey = 'empty';
		let cacheKey = '';

		Object.keys(state).forEach((key) => {
			if (key.indexOf('term_group_') !== -1) {
				cacheKey +=
					state[key].length > 0 ? state[key].join('-') : emptyKey;
				cacheKey += '-';
			}
		});

		this.state.desktop.key = cacheKey;
	}


	async getData() {
		const state = this.state.desktop;
		let data = null;
		if (state.cache.has(state.key)) {
			data = state.cache.get(state.key);
		} else {
			const response = await this.getDataAjax();
			data = response.data;
			this.state.desktop.cache.set(state.key, data);
		}

		return data;
	}

	async getDataAjax() {
		const state = this.state;
		const data = {
			action: 'nx_business_types_widget_get_data',
			nonce: state.nonce,
			postIds: [],
		};

		Object.keys(state.desktop).forEach((key) => {
			if (key.indexOf('term_group_') !== -1) {
				data.postIds = data.postIds.concat(state.desktop[key]);
			}
		});

		return Promise.resolve(jQuery.post('/wp-admin/admin-ajax.php', data));
	}

	filterFormSubmitHandler(event) {
		event.preventDefault();
		this.setCacheKey();
		this.loader.show(this.selectors.desktop.wrapper);
	}

	filterFormSelectChangeHandler(event) {
		const $target = jQuery(event.currentTarget);
		const key = $target.attr('name');
		if (!key) {
			return;
		}

		const id = parseInt($target.val());
		this.state.desktop[key] =
			id === 0 ? BUSINESS_TYPE_SHORTCODE_CONFIG[key].post_ids : [id];

		this.selectors.desktop.filterForm.wrapper.trigger('submit');
	}



	accordionMobileClickHandler(event) {
		const $target = jQuery(event.currentTarget);
		const $parent = $target.parent();
		if ($parent.length < 1) {
			return;
		}

		if (!$parent.hasClass('active')) {
			this.accordionMobileHidePrevActive($parent);
		}

		$parent.toggleClass('active');
		const $panel = $parent.find('.panel');
		if ($panel.length > 0) {
			$panel.slideToggle();
		}
	}

	accordionMobileHidePrevActive($item) {
		const $accordion = $item.parent();
		const $activeItem = $accordion.find('.item.active');
		if ($activeItem.length < 1) {
			return;
		}

		$activeItem.removeClass('active');
		const $activePanel = $activeItem.find('.panel');
		if ($activePanel.length > 0) {
			$activePanel.slideUp();
		}
	}
}